import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PortalIdParser from 'PortalIdParser';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { getFullUrl } from 'hubspot-url-utils';
import { ROUTING_SOURCE } from '../../shared/constants/routing-source';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomerAgentHandoffLink = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Link, {
    href: `${getFullUrl('app')}/customer-agent/${PortalIdParser.get()}/manage/handoff`,
    children: children
  });
};
CustomerAgentHandoffLink.displayName = 'CustomerAgentHandoffLink';
export const CustomerAgentRow = ({
  routingSource
}) => {
  return /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsx(Text, {
      children: routingSource === ROUTING_SOURCE.HELP_DESK ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "routing-ui.routingRules.fallback.customerAgentLabel.helpDesk_jsx",
        elements: {
          Link: CustomerAgentHandoffLink
        }
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "routing-ui.routingRules.fallback.customerAgentLabel.generic_jsx",
        elements: {
          Link: CustomerAgentHandoffLink
        }
      })
    })
  });
};
CustomerAgentRow.displayName = 'CustomerAgentRow';